import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const ReplySimple = ({
  width = 16,
  height = 16,
  fillColor,
  style
}: BaseSVGType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g opacity="0.4">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.4714 2.19526C6.73173 2.45561 6.73173 2.87772 6.4714 3.13807L4.27614 5.33333H8C10.9455 5.33333 13.3333 7.72115 13.3333 10.6667V13.3334C13.3333 13.7016 13.0349 14 12.6667 14C12.2985 14 12 13.7016 12 13.3334V10.6667C12 8.45755 10.2091 6.66667 8 6.66667H4.27614L6.4714 8.86195C6.73173 9.12229 6.73173 9.54442 6.4714 9.80475C6.21105 10.0651 5.78895 10.0651 5.52859 9.80475L2.19526 6.47141C1.93491 6.21105 1.93491 5.78895 2.19526 5.52859L5.52859 2.19526C5.78895 1.93491 6.21105 1.93491 6.4714 2.19526Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default ReplySimple;
